import React from "react";
import ReactDOM from "react-dom";
import UpcomingEventsCalendars from "./containers/UpcomingEventsCalendars";
import {getElementsProperty} from "../helpers/getElementsProperty";

export const initUpcomingEventsCalendars = className => {
  getElementsProperty(className, (property, element) => {
    ReactDOM.render(<UpcomingEventsCalendars url={property.url} />, element);
  });
};
